import React from "react";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";

export function CedenteForm({ data, onChange }) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>Nome Completo</Label>
        <Input
          value={data.nome}
          onChange={e => onChange({ ...data, nome: e.target.value })}
          placeholder="Nome do substituído"
        />
      </div>
      <div className="space-y-2">
        <Label>CPF</Label>
        <Input
          value={data.cpf}
          onChange={e => {
            const rawValue = e.target.value;
            // Let's keep only numbers for simplicity in the mask or just use standard formatting later.
            // For now, accept straight numbers
            const onlyDigits = rawValue.replace(/\D/g, "");
            let formatted = onlyDigits;
            if (onlyDigits.length <= 11) {
              formatted = onlyDigits
                .replace(/(\d{3})(\d)/, "$1.$2")
                .replace(/(\d{3})(\d)/, "$1.$2")
                .replace(/(\d{3})(\d{1,2})/, "$1-$2");
            } else {
              formatted = rawValue;
            }
            onChange({ ...data, cpf: formatted });
          }}
          placeholder="000.000.000-00"
          maxLength={14}
        />
      </div>
      <div className="flex items-center space-x-2 pt-2">
        <input
          type="checkbox"
          id="ativo-checkbox"
          checked={data.ativo !== false}
          onChange={e => onChange({ ...data, ativo: e.target.checked })}
          className="h-4 w-4 rounded border-gray-300 text-foreground focus:ring-slate-900"
        />
        <Label htmlFor="ativo-checkbox" className="text-sm font-medium text-foreground cursor-pointer">
          Substituído Ativo (Permitir acesso ao sistema)
        </Label>
      </div>
    </div>
  );
}
